const _temp0 = require("../category/VProjectorCategory.vue");
const _temp1 = require("../category/VProjectorCategoryDefault.vue");

const _temp2 = require("../item/VProjectorItem.vue");
const _temp3 = require("../item/VProjectorItemV17.vue");

module.exports = {
  "category":   {
    "VProjectorCategory": _temp0,
    "VProjectorCategoryDefault": _temp1
  },
  "item":   {
    "VProjectorItem": _temp2,
    "VProjectorItemV17": _temp3
  }
}